import { Heading, Separator, Stack } from "@generalapplications/ui";

import { ArticleCardGrid } from "@/app/features/blog/components/ArticleCardGrid";
import type { BlogPostSummary } from "@/content/blog";

export type RelatedArticlesProps = {
  posts: BlogPostSummary[];
};

/** Further reading under an article. */
export function RelatedArticles({ posts }: RelatedArticlesProps) {
  if (posts.length === 0) return null;

  return (
    <Stack as="section" gap="lg">
      <Separator />
      <Heading level={2} size="xl">
        Related Reads
      </Heading>
      <ArticleCardGrid posts={posts} ariaLabel="Related articles" />
    </Stack>
  );
}
